module.exports = __webpack_public_path__ + "media/scholarship_winners/francisco-r-e1d0ff33.png";